export const LANGUAGES = [
  { code: "tr", name: "Türkçe", flag: "🇹🇷" },
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "fr", name: "Français", flag: "🇫🇷" },
  { code: "de", name: "Deutsch", flag: "🇩🇪" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "ru", name: "Русский", flag: "🇷🇺" },
  { code: "ar", name: "العربية", flag: "🇸🇦" },
];

export const legalTranslations = {
  tr: {
    themeToggleLight: "Koyu moda geç",
    themeToggleDark: "Açık moda geç",
    backToHome: "Ana Sayfa",
    privacyPolicy: "Gizlilik Sözleşmesi",
    termsOfService: "Kullanım Koşulları",
    cookiePolicy: "Çerez Politikası",
    footerRights: "Tüm hakları saklıdır.",
    privacyTitle: "Gizlilik Sözleşmesi",
    termsTitle: "Kullanım Koşulları",
    cookieTitle: "Çerez Politikası",
    accountDeletion: "Hesabımı Sil",
    accountDeletionTitle: "Hesap Silme",
    accountDeletionDesc: "Hesabınızı kalıcı olarak silmek için e-posta adresinizi girin. Size gönderilecek 6 haneli OTP kodunu doğruladıktan sonra hesabınız silinecektir.",
    accountDeletionEmailLabel: "E-posta adresi",
    accountDeletionSendOtp: "OTP Gönder",
    accountDeletionSending: "Gönderiliyor...",
    accountDeletionOtpInfo: "E-posta adresinize gönderilen 6 haneli kodu girin.",
    accountDeletionOtpLabel: "OTP Kodu",
    accountDeletionConfirm: "Hesabı Sil",
    accountDeletionDeleting: "Siliniyor...",
    accountDeletionBack: "Geri",
    accountDeletionSuccess: "Hesabınız başarıyla silindi.",
    accountDeletionGoHome: "Ana Sayfaya Dön",
  },
  en: {
    themeToggleLight: "Switch to dark mode",
    themeToggleDark: "Switch to light mode",
    backToHome: "Home",
    privacyPolicy: "Privacy Policy",
    termsOfService: "Terms of Service",
    cookiePolicy: "Cookie Policy",
    footerRights: "All rights reserved.",
    privacyTitle: "Privacy Policy",
    termsTitle: "Terms of Service",
    cookieTitle: "Cookie Policy",
    accountDeletion: "Delete My Account",
    accountDeletionTitle: "Account Deletion",
    accountDeletionDesc: "Enter your email address to permanently delete your account. After verifying the 6-digit OTP code sent to you, your account will be deleted.",
    accountDeletionEmailLabel: "Email address",
    accountDeletionSendOtp: "Send OTP",
    accountDeletionSending: "Sending...",
    accountDeletionOtpInfo: "Enter the 6-digit code sent to your email.",
    accountDeletionOtpLabel: "OTP Code",
    accountDeletionConfirm: "Delete Account",
    accountDeletionDeleting: "Deleting...",
    accountDeletionBack: "Back",
    accountDeletionSuccess: "Your account has been successfully deleted.",
    accountDeletionGoHome: "Back to Home",
  },
  fr: {
    themeToggleLight: "Passer en mode sombre",
    themeToggleDark: "Passer en mode clair",
    backToHome: "Accueil",
    privacyPolicy: "Politique de confidentialité",
    termsOfService: "Conditions d'utilisation",
    cookiePolicy: "Politique des cookies",
    footerRights: "Tous droits réservés.",
    privacyTitle: "Politique de confidentialité",
    termsTitle: "Conditions d'utilisation",
    cookieTitle: "Politique des cookies",
    accountDeletion: "Supprimer mon compte",
    accountDeletionTitle: "Suppression de compte",
    accountDeletionDesc: "Entrez votre adresse e-mail pour supprimer définitivement votre compte. Après avoir vérifié le code OTP à 6 chiffres envoyé, votre compte sera supprimé.",
    accountDeletionEmailLabel: "Adresse e-mail",
    accountDeletionSendOtp: "Envoyer OTP",
    accountDeletionSending: "Envoi...",
    accountDeletionOtpInfo: "Entrez le code à 6 chiffres envoyé à votre e-mail.",
    accountDeletionOtpLabel: "Code OTP",
    accountDeletionConfirm: "Supprimer le compte",
    accountDeletionDeleting: "Suppression...",
    accountDeletionBack: "Retour",
    accountDeletionSuccess: "Votre compte a été supprimé avec succès.",
    accountDeletionGoHome: "Retour à l'accueil",
  },
  de: {
    themeToggleLight: "Zum dunklen Modus wechseln",
    themeToggleDark: "Zum hellen Modus wechseln",
    backToHome: "Startseite",
    privacyPolicy: "Datenschutzrichtlinie",
    termsOfService: "Nutzungsbedingungen",
    cookiePolicy: "Cookie-Richtlinie",
    footerRights: "Alle Rechte vorbehalten.",
    privacyTitle: "Datenschutzrichtlinie",
    termsTitle: "Nutzungsbedingungen",
    cookieTitle: "Cookie-Richtlinie",
    accountDeletion: "Mein Konto löschen",
    accountDeletionTitle: "Kontolöschung",
    accountDeletionDesc: "Geben Sie Ihre E-Mail-Adresse ein, um Ihr Konto dauerhaft zu löschen. Nach der Überprüfung des an Sie gesendeten 6-stelligen OTP-Codes wird Ihr Konto gelöscht.",
    accountDeletionEmailLabel: "E-Mail-Adresse",
    accountDeletionSendOtp: "OTP senden",
    accountDeletionSending: "Wird gesendet...",
    accountDeletionOtpInfo: "Geben Sie den an Ihre E-Mail gesendeten 6-stelligen Code ein.",
    accountDeletionOtpLabel: "OTP-Code",
    accountDeletionConfirm: "Konto löschen",
    accountDeletionDeleting: "Wird gelöscht...",
    accountDeletionBack: "Zurück",
    accountDeletionSuccess: "Ihr Konto wurde erfolgreich gelöscht.",
    accountDeletionGoHome: "Zurück zur Startseite",
  },
  es: {
    themeToggleLight: "Cambiar a modo oscuro",
    themeToggleDark: "Cambiar a modo claro",
    backToHome: "Inicio",
    privacyPolicy: "Política de privacidad",
    termsOfService: "Términos de servicio",
    cookiePolicy: "Política de cookies",
    footerRights: "Todos los derechos reservados.",
    privacyTitle: "Política de privacidad",
    termsTitle: "Términos de servicio",
    cookieTitle: "Política de cookies",
    accountDeletion: "Eliminar mi cuenta",
    accountDeletionTitle: "Eliminación de cuenta",
    accountDeletionDesc: "Ingrese su dirección de correo electrónico para eliminar permanentemente su cuenta. Después de verificar el código OTP de 6 dígitos enviado, su cuenta será eliminada.",
    accountDeletionEmailLabel: "Dirección de correo electrónico",
    accountDeletionSendOtp: "Enviar OTP",
    accountDeletionSending: "Enviando...",
    accountDeletionOtpInfo: "Ingrese el código de 6 dígitos enviado a su correo electrónico.",
    accountDeletionOtpLabel: "Código OTP",
    accountDeletionConfirm: "Eliminar cuenta",
    accountDeletionDeleting: "Eliminando...",
    accountDeletionBack: "Atrás",
    accountDeletionSuccess: "Su cuenta ha sido eliminada correctamente.",
    accountDeletionGoHome: "Volver al inicio",
  },
  ru: {
    themeToggleLight: "Переключить на тёмный режим",
    themeToggleDark: "Переключить на светлый режим",
    backToHome: "Главная",
    privacyPolicy: "Политика конфиденциальности",
    termsOfService: "Условия использования",
    cookiePolicy: "Политика cookies",
    footerRights: "Все права защищены.",
    privacyTitle: "Политика конфиденциальности",
    termsTitle: "Условия использования",
    cookieTitle: "Политика cookies",
    accountDeletion: "Удалить мой аккаунт",
    accountDeletionTitle: "Удаление аккаунта",
    accountDeletionDesc: "Введите свой адрес электронной почты для постоянного удаления аккаунта. После проверки 6-значного OTP-кода, отправленного вам, ваш аккаунт будет удалён.",
    accountDeletionEmailLabel: "Адрес электронной почты",
    accountDeletionSendOtp: "Отправить OTP",
    accountDeletionSending: "Отправка...",
    accountDeletionOtpInfo: "Введите 6-значный код, отправленный на вашу почту.",
    accountDeletionOtpLabel: "OTP-код",
    accountDeletionConfirm: "Удалить аккаунт",
    accountDeletionDeleting: "Удаление...",
    accountDeletionBack: "Назад",
    accountDeletionSuccess: "Ваш аккаунт успешно удалён.",
    accountDeletionGoHome: "На главную",
  },
  ar: {
    themeToggleLight: "التبديل إلى الوضع الداكن",
    themeToggleDark: "التبديل إلى الوضع الفاتح",
    backToHome: "الرئيسية",
    privacyPolicy: "سياسة الخصوصية",
    termsOfService: "شروط الاستخدام",
    cookiePolicy: "سياسة ملفات تعريف الارتباط",
    footerRights: "جميع الحقوق محفوظة.",
    privacyTitle: "سياسة الخصوصية",
    termsTitle: "شروط الاستخدام",
    cookieTitle: "سياسة ملفات تعريف الارتباط",
    accountDeletion: "حذف حسابي",
    accountDeletionTitle: "حذف الحساب",
    accountDeletionDesc: "أدخل عنوان بريدك الإلكتروني لحذف حسابك نهائياً. بعد التحقق من رمز OTP المكون من 6 أرقام المرسل إليك، سيتم حذف حسابك.",
    accountDeletionEmailLabel: "عنوان البريد الإلكتروني",
    accountDeletionSendOtp: "إرسال OTP",
    accountDeletionSending: "جاري الإرسال...",
    accountDeletionOtpInfo: "أدخل الرمز المكون من 6 أرقام المرسل إلى بريدك الإلكتروني.",
    accountDeletionOtpLabel: "رمز OTP",
    accountDeletionConfirm: "حذف الحساب",
    accountDeletionDeleting: "جاري الحذف...",
    accountDeletionBack: "رجوع",
    accountDeletionSuccess: "تم حذف حسابك بنجاح.",
    accountDeletionGoHome: "العودة للرئيسية",
  },
};
